import { render, staticRenderFns } from "./annual-sale-2020-banner.vue?vue&type=template&id=1cfa9e68&"
import script from "./annual-sale-2020-banner.vue?vue&type=script&lang=js&"
export * from "./annual-sale-2020-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports